import React from 'react';

const Web_Storage_API = () => {
  return (
    <div >
      <h1>Web_Storage_API</h1>
      <p>Placeholder component for: "Web Storage API"</p>
    </div>
  );
};

export default Web_Storage_API;
